import { createFileRoute } from '@tanstack/react-router'

import { CamerasScreen } from '@/components/cameras/cameras-screen'
import { useAuth } from '@/hooks/use-auth'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agriculture/cameras',
)({
    component: CamerasPage,
})

/** Danh sách / quản lý toàn bộ camera — theo quyền của module camera. */
export function CamerasPage() {
    const { hasPermission } = useAuth()
    if (!hasPermission('cameras.read')) {
        return (
            <div className="p-8 text-center text-destructive">
                {m.common_permission_denied()}
            </div>
        )
    }
    return <CamerasScreen />
}
